import { css } from '@emotion/core'

export const cssGroup = css`
display: grid;
`
